import _slicedToArray from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _marketConfig;
import './index.css';
import i18next from 'i18next';
import { GB, ZA, AU, CA, NZ, EN_GB, EN_AU } from '@clearscore-group/lib.config.i18n';
import React, { useRef, useState, useEffect } from 'react';
import ClickableIcon from '@clearscore/ui.rainbow.clickable-icon';
import HamburgerIcon from '@clearscore/rainbow.icons.menu-hamburger';
import ClearScoreLogo$1 from '@clearscore/rainbow.icons.clearscore-logo-symbol';
import ClearScoreLogoLarge from '@clearscore/rainbow.icons.clearscore-logo-wordmark';
import Button from '@clearscore/ui.rainbow.button';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import useMarketConfig from '@clearscore-group/lib.hooks.use-market-config-deprecated';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import CloseIcon from '@clearscore/rainbow.icons.cross';
import ClearScoreLogo from '@clearscore/rainbow.icons.clearscore';
import FocusTrap from 'focus-trap-react';
import useWesbiteTracking from '@clearscore-group/lib.hooks.use-website-tracking';
var COMPONENT_NAMESPACE = 'navigation';
var styles$2 = {
  "navigationContent": "navigationContent--NEUkg",
  "HideMenuLinks": "HideMenuLinks--PcLsu",
  "open": "open--LHCPv",
  "navigationContentActions": "navigationContentActions--TLYP2",
  "navigationContentActionsItem": "navigationContentActionsItem--1Ovj6",
  "navigationContentCTAs": "navigationContentCTAs--J9NyJ",
  "navigationContentItems": "navigationContentItems--T0o3n"
};
var marketConfig = (_marketConfig = {}, _defineProperty(_marketConfig, GB, {
  home: {
    id: 'home',
    href: '/'
  },
  signUp: {
    id: 'signup',
    href: '//app.clearscore.com/signup'
  },
  login: {
    id: 'login',
    href: '//app.clearscore.com/login'
  },
  links: [{
    id: 'creditScore',
    href: '/credit-scores'
  }, {
    id: 'creditCards',
    href: '/credit-cards'
  }, {
    id: 'loans',
    href: '/loans'
  }, {
    id: 'carFinance',
    href: '/car-finance'
  }, {
    id: 'aboutUs',
    href: '/about-us'
  }, {
    id: 'learn',
    href: '/learn'
  }]
}), _defineProperty(_marketConfig, ZA, {
  home: {
    id: 'home',
    href: '/za'
  },
  signUp: {
    id: 'signup',
    href: '//app.clearscore.com/signup?lng=en-za'
  },
  login: {
    id: 'login',
    href: '//app.clearscore.com/login'
  },
  links: [{
    id: 'creditScore',
    href: '/za/credit-scores'
  }, {
    id: 'loans',
    href: '/za/loans'
  }, {
    id: 'creditCards',
    href: '/za/credit-cards'
  }, {
    id: 'protect',
    href: '/za/protect'
  }, {
    id: 'aboutUs',
    href: '/za/about-us'
  }, {
    id: 'learn',
    href: '/za/learn'
  }, {
    id: 'careers',
    href: '/za/careers',
    target: '_blank'
  }, {
    id: 'help',
    href: '//help.clearscore.co.za/hc/en-us',
    target: '_blank'
  }]
}), _defineProperty(_marketConfig, AU, {
  home: {
    id: 'home',
    href: '/au'
  },
  signUp: {
    id: 'signup',
    href: '//app.clearscore.com/signup?lng=en-au'
  },
  login: {
    id: 'login',
    href: '//app.clearscore.com/login?lng=en-au'
  },
  links: [{
    id: 'creditScore',
    href: '/au/credit-scores'
  }, {
    id: 'loans',
    href: '/au/personal-loans'
  }, {
    id: 'creditCards',
    href: '/au/credit-cards'
  }, {
    id: 'protect',
    href: '/au/protect'
  }, {
    id: 'aboutUs',
    href: '/au/about-us'
  }, {
    id: 'learn',
    href: '/au/learn'
  }, {
    id: 'careers',
    href: '/au/careers',
    target: '_blank'
  }, {
    id: 'help',
    href: '//help.clearscore.com.au/hc/en-us',
    target: '_blank'
  }],
  protectNavLinks: ['aboutUs', 'learn', 'careers']
}), _defineProperty(_marketConfig, CA, {
  home: {
    id: 'home',
    href: '/ca'
  },
  signUp: {
    id: 'signup',
    href: '//app.clearscore.com/signup?lng=en-ca'
  },
  login: {
    id: 'login',
    href: '//app.clearscore.com/login'
  },
  links: [{
    id: 'creditScore',
    href: '/ca/credit-scores'
  }, {
    id: 'creditCards',
    href: '/ca/credit-cards'
  }, {
    id: 'protect',
    href: '/ca/protect'
  }, {
    id: 'aboutUs',
    href: '/ca/about-us'
  }, {
    id: 'learn',
    href: '/ca/learn'
  }, {
    id: 'careers',
    href: '/ca/careers',
    target: '_blank'
  }, {
    id: 'help',
    href: 'https://help.clearscore.ca/hc/en-us',
    target: '_blank'
  }],
  protectNavLinks: ['creditScore', 'creditCards', 'protect', 'aboutUs', 'careers', 'help']
}), _defineProperty(_marketConfig, NZ, {
  home: {
    id: 'home',
    href: '/nz'
  },
  signUp: {
    id: 'signup',
    href: '//app.clearscore.com/signup?lng=en-nz'
  },
  login: {
    id: 'login',
    href: '//app.clearscore.com/login?lng=en-nz'
  },
  links: [{
    id: 'aboutUs',
    href: '/nz/about-us'
  }, {
    id: 'careers',
    href: '/nz/careers',
    target: '_blank'
  }, {
    id: 'help',
    href: 'https://help.clearscore.nz/hc/en-gb',
    target: '_blank'
  }]
}), _marketConfig);
var SIGN_UP_EVENT = 'fe_website_navigation_signup_clicked';
var LOGIN_EVENT = 'fe_website_navigation_login_clicked';
var HEADER_EVENT = 'fe_website_navigation_link_clicked';
var useWebsiteTracking = function useWebsiteTracking() {
  var track = useWesbiteTracking();
  return {
    trackHeaderLink: function trackHeaderLink(_ref) {
      var href = _ref.href,
        e = _ref.e,
        isNewTab = _ref.isNewTab,
        _ref$label = _ref.label,
        label = _ref$label === void 0 ? 'home' : _ref$label;
      if (e && !isNewTab) e.preventDefault();
      return track({
        name: HEADER_EVENT,
        props: {
          cta_url: href,
          cta_copy: label,
          e: HEADER_EVENT
        },
        onComplete: function onComplete() {
          if (!isNewTab) {
            window.location.assign(href);
          }
        }
      });
    },
    trackSignUp: function trackSignUp(_ref2) {
      var ctaCopy = _ref2.ctaCopy,
        href = _ref2.href,
        e = _ref2.e;
      if (e) e.preventDefault();
      return track({
        name: SIGN_UP_EVENT,
        props: {
          cta_url: href,
          cta_copy: ctaCopy,
          e: SIGN_UP_EVENT
        },
        onComplete: function onComplete() {
          window.location.assign(href);
        }
      });
    },
    trackLogin: function trackLogin(_ref3) {
      var ctaCopy = _ref3.ctaCopy,
        href = _ref3.href,
        e = _ref3.e;
      if (e) e.preventDefault();
      return track({
        name: LOGIN_EVENT,
        props: {
          cta_url: href,
          cta_copy: ctaCopy,
          e: LOGIN_EVENT
        },
        onComplete: function onComplete() {
          window.location.assign(href);
        }
      });
    }
  };
};
var styles$1 = {
  "navigationItem": "navigationItem--FxUTk"
};
var NavigationItem = function NavigationItem(_ref4) {
  var href = _ref4.href,
    label = _ref4.label,
    onClick = _ref4.onClick,
    target = _ref4.target,
    id = _ref4.id,
    children = _ref4.children,
    className = _ref4.className,
    dataId = _ref4['data-id'],
    ariaLabel = _ref4['aria-label'];
  return /*#__PURE__*/React.createElement("a", {
    className: className || styles$1.navigationItem,
    "data-id": dataId,
    href: href,
    onClick: onClick,
    target: target,
    key: id,
    "aria-label": ariaLabel || label
  }, label, children);
};
var NavigationContent = function NavigationContent(_ref5) {
  var isOpen = _ref5.isOpen,
    setOpen = _ref5.setOpen,
    links = _ref5.links;
  var _useTranslation = useTranslation(COMPONENT_NAMESPACE),
    t = _useTranslation.t;
  var _useMarketConfig = useMarketConfig(marketConfig),
    home = _useMarketConfig.home,
    signUp = _useMarketConfig.signUp,
    login = _useMarketConfig.login;
  var _useWebsiteTracking = useWebsiteTracking(),
    trackLogin = _useWebsiteTracking.trackLogin,
    trackSignUp = _useWebsiteTracking.trackSignUp,
    trackHeaderLink = _useWebsiteTracking.trackHeaderLink;
  return /*#__PURE__*/React.createElement(FocusTrap, {
    active: isOpen
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles$2.navigationContent, _defineProperty({}, styles$2.open, isOpen)),
    "data-id": "website-navigation-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2.navigationContentActions
  }, /*#__PURE__*/React.createElement(NavigationItem, {
    href: home.href,
    id: home.id,
    onClick: function onClick(e) {
      return trackHeaderLink({
        href: home.href,
        e: e
      });
    },
    className: styles$2.navigationContentActionsItem,
    "aria-label": t('links.home')
  }, /*#__PURE__*/React.createElement(ClearScoreLogo, {
    height: 32,
    width: 32,
    title: t('links.home')
  })), /*#__PURE__*/React.createElement("button", {
    className: styles$2.navigationContentActionsItem,
    type: "button",
    onClick: function onClick() {
      return setOpen(false);
    },
    "aria-label": t('actions.close')
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    height: 32,
    width: 32
  }))), /*#__PURE__*/React.createElement("ul", {
    className: styles$2.navigationContentItems
  }, links.map(function (link) {
    return /*#__PURE__*/React.createElement("li", {
      key: link.id,
      className: styles$2.navigationContentLink
    }, /*#__PURE__*/React.createElement(NavigationItem, _objectSpread(_objectSpread({}, link), {}, {
      onClick: function onClick(e) {
        return trackHeaderLink({
          href: link.href,
          e: e
        });
      }
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$2.navigationContentCTAs
  }, /*#__PURE__*/React.createElement(Button, {
    href: signUp.href,
    isWide: true,
    type: "SECONDARY",
    theme: "DARK",
    size: "LARGE",
    isDisabled: !isOpen,
    "aria-label": t('actions.signup'),
    onClick: function onClick(e) {
      return trackSignUp({
        href: signUp.href,
        ctaCopy: t('actions.signup'),
        e: e
      });
    }
  }, t('actions.signup')), /*#__PURE__*/React.createElement(Button, {
    href: login.href,
    isWide: true,
    type: "PRIMARY",
    theme: "DARK",
    size: "LARGE",
    isDisabled: !isOpen,
    "aria-label": t('actions.login'),
    onClick: function onClick(e) {
      return trackLogin({
        href: login.href,
        ctaCopy: t('actions.login'),
        e: e
      });
    }
  }, t('actions.login')))));
};
var styles = {
  "navigation": "navigation--e7Tqp",
  "relative": "relative--CtS2r",
  "scrolled": "scrolled--XbHEe",
  "open": "open--6SgmT",
  "navigationHamburger": "navigationHamburger--GypWV",
  "navigationLogo": "navigationLogo--9cNP4",
  "small": "small--1BdBf",
  "large": "large--5WWA1",
  "navigationCTAs": "navigationCTAs--brMnd",
  "navigationScrollMarker": "navigationScrollMarker--9Iak8"
};

/* eslint-disable import/prefer-default-export */
var detectFullyQualifiedUrlRegex = /^(http[s]*:){0,1}(\/\/){0,1}(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}/i; // eslint-disable-line max-len

var detectFullyQualifiedUrl = function detectFullyQualifiedUrl(href) {
  return detectFullyQualifiedUrlRegex.test(href);
};
var injectDomain = function injectDomain(domain, href) {
  return "".concat(domain && href && !detectFullyQualifiedUrl(href) ? domain : '').concat(href);
};
var formatLinks = function formatLinks(_ref6) {
  var links = _ref6.links,
    config = _ref6.config,
    filter = _ref6.filter;
  var filteredLinks = links;
  if (config !== null && config !== void 0 && config.isProtect && filter) {
    filteredLinks = filteredLinks.filter(function (link) {
      return link.label && filter.includes(link.label) || link.id !== 'help';
    });
  }
  return filteredLinks.map(function (link) {
    return _objectSpread(_objectSpread({}, link), {}, {
      href: injectDomain((config === null || config === void 0 ? void 0 : config.domain) || '', link.href)
    });
  });
};
var useNavigationLinks = function useNavigationLinks(_ref7) {
  var links = _ref7.links,
    config = _ref7.config,
    filter = _ref7.filter,
    market = _ref7.market;
  var _useTranslation2 = useTranslation(COMPONENT_NAMESPACE),
    t = _useTranslation2.t;
  var navLinks = (links || market.links).map(function (link) {
    return {
      id: link.id,
      href: link.href,
      label: t("links.".concat(link.id)),
      target: link.target
    };
  });
  return formatLinks({
    config: config,
    links: navLinks,
    filter: filter
  });
};
var Navigation = function Navigation(_ref8) {
  var _cx2;
  var config = _ref8.config,
    links = _ref8.links,
    scrollRef = _ref8.scrollRef,
    relativePosition = _ref8.relativePosition;
  var _useTranslation3 = useTranslation(COMPONENT_NAMESPACE),
    t = _useTranslation3.t;
  var market = useMarketConfig(marketConfig);
  var defaultScrollRef = useRef((scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) || null);
  var navLinks = useNavigationLinks({
    links: links,
    config: config,
    market: market
  });
  var _useWebsiteTracking2 = useWebsiteTracking(),
    trackLogin = _useWebsiteTracking2.trackLogin,
    trackSignUp = _useWebsiteTracking2.trackSignUp,
    trackHeaderLink = _useWebsiteTracking2.trackHeaderLink;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(window.scrollY > 0),
    _useState4 = _slicedToArray(_useState3, 2),
    hasScrolled = _useState4[0],
    setHasScrolled = _useState4[1];
  var setOpen = function setOpen(open) {
    setIsOpen(open);
  };
  useEffect(function () {
    var ref = (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) || defaultScrollRef.current;
    if (!ref) return;
    var observer = new IntersectionObserver(function (e) {
      return setHasScrolled(!e[0].isIntersecting);
    });
    observer.observe(ref);
    // eslint-disable-next-line consistent-return
    return function () {
      return observer.disconnect();
    };
  }, [defaultScrollRef]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("nav", {
    className: cx(styles.navigation, (_cx2 = {}, _defineProperty(_cx2, styles.open, isOpen), _defineProperty(_cx2, styles.scrolled, hasScrolled), _defineProperty(_cx2, styles.relative, relativePosition), _cx2))
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.navigationHamburger
  }, /*#__PURE__*/React.createElement(ClickableIcon, {
    onClick: function onClick() {
      return setOpen(true);
    },
    isDisabled: isOpen,
    ariaLabel: t('actions.open')
  }, /*#__PURE__*/React.createElement(HamburgerIcon, {
    height: 32,
    width: 32,
    title: t('actions.open')
  }))), /*#__PURE__*/React.createElement(NavigationItem, {
    href: market.home.href,
    id: market.home.id,
    "aria-label": t('links.home'),
    onClick: function onClick(e) {
      return trackHeaderLink({
        href: market.home.href,
        e: e
      });
    },
    className: styles.navigationLogo
  }, /*#__PURE__*/React.createElement(ClearScoreLogo$1, {
    className: cx(styles.navigationLogo, styles.small)
  }), /*#__PURE__*/React.createElement(ClearScoreLogoLarge, {
    className: cx(styles.navigationLogo, styles.large)
  })), /*#__PURE__*/React.createElement(NavigationContent, {
    links: navLinks,
    isOpen: isOpen,
    setOpen: setOpen
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.navigationCTAs
  }, /*#__PURE__*/React.createElement(Button, {
    href: market.signUp.href,
    isNarrow: true,
    type: "TERTIARY",
    theme: "DARK",
    isDisabled: isOpen,
    "aria-label": t('actions.signup'),
    onClick: function onClick(e) {
      return trackSignUp({
        href: market.signUp.href,
        ctaCopy: t('actions.signup'),
        e: e
      });
    }
  }, t('actions.signup')), /*#__PURE__*/React.createElement(Button, {
    href: market.login.href,
    isNarrow: true,
    type: "SECONDARY",
    theme: "DARK",
    isDisabled: isOpen,
    "aria-label": t('actions.login'),
    onClick: function onClick(e) {
      return trackLogin({
        href: market.login.href,
        ctaCopy: t('actions.login'),
        e: e
      });
    }
  }, t('actions.login')))), !(scrollRef !== null && scrollRef !== void 0 && scrollRef.current) ? /*#__PURE__*/React.createElement("span", {
    ref: defaultScrollRef,
    className: styles.navigationScrollMarker
  }) : null);
};
var actions = {
  signup: "Sign up",
  login: "Log in",
  close: "Close Menu",
  open: "Open Menu"
};
var links$1 = {
  home: "Home",
  creditScore: "Credit Score & Report",
  creditCards: "Credit cards",
  loans: "Loans",
  carFinance: "Car finance",
  aboutUs: "About us",
  learn: "Learn",
  careers: "Careers",
  protect: "Protect",
  help: "Help"
};
var copyEnGb = {
  actions: actions,
  links: links$1
};
var links = {
  loans: "Personal loans"
};
var copyEnAu = {
  links: links
};
i18next.addResourceBundle(EN_GB, COMPONENT_NAMESPACE, copyEnGb);
i18next.addResourceBundle(EN_AU, COMPONENT_NAMESPACE, copyEnAu);
export { Navigation, NavigationContent };